import { render, staticRenderFns } from "./Accessory.vue?vue&type=template&id=a94049c2&scoped=true"
import script from "./Accessory.vue?vue&type=script&lang=js"
export * from "./Accessory.vue?vue&type=script&lang=js"
import style0 from "./Accessory.vue?vue&type=style&index=0&id=a94049c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94049c2",
  null
  
)

export default component.exports